export const SUPPORTED_LANGUAGES = ['tr', 'en'];

const ADMIN_PATHS = new Set([
  '/login',
  '/add-product',
  '/add-english-product',
  '/manage-products',
  '/manage-english-products',
  '/order-products',
  '/add-catalog',
  '/manage-catalogs',
  '/add-documents',
  '/manage-documents',
]);

export const isSupportedLanguage = (language) =>
  SUPPORTED_LANGUAGES.includes(language);

export const isPublicPath = (pathname) => !ADMIN_PATHS.has(pathname);

export const getLanguageFromSearch = (search) => {
  const language = new URLSearchParams(search).get('lang');
  return isSupportedLanguage(language) ? language : null;
};

export const withLanguage = (target, language) => {
  const url = new URL(target, 'https://krlkimya.com');
  url.searchParams.set('lang', language);
  return `${url.pathname}${url.search}${url.hash}`;
};

export const withoutLanguage = (target) => {
  const url = new URL(target, 'https://krlkimya.com');
  url.searchParams.delete('lang');
  return `${url.pathname}${url.search}${url.hash}`;
};
